import moment from 'moment';
import { getAll, graphQL } from '../../api';
import { getScreensByGroup } from '../../api/modules/screenStats';

const state = {
  details: {
    users: {
      items: {
        0: {},
      },
    },
    area: {},
  },
  graphLoadingStates: {
    networkHealth: true,
  },
  statusChart: {},
  groupLocations: [],
  updateInProgress: false,
  editingDetails: false,
  updated: false,
  adJson: false, // modal
  interfaceTypes: [],
};

const getters = {
  getDetails(state) {
    return state.details;
  },
  getGroupLocations(state) {
    return state.groupLocations;
  },
  getUpdateInProgress(state) {
    return state.updateInProgress;
  },
  getStatusChart(state) {
    return state.statusChart;
  },
  getEditingDetails(state) {
    return state.editingDetails;
  },
  getUpdated(state) {
    return state.updated;
  },
  getAdJson(state) {
    return state.adJson;
  },
  getInterfaceTypes(state) {
    return state.interfaceTypes;
  },
  getGraphLoadingStates: state => state.graphLoadingStates,
};

const actions = {
  acquireDetails: async ({ commit, dispatch, rootGetters }, payload) => {
    if (rootGetters['account/getCurrentClient'].client_name === 'shark') {
      dispatch('acquireSharkDetails', payload);
    } else {
      commit('setUpdateInProgress', true);
      commit('loading/setLoading', true, { root: true });
      return new Promise((resolve, reject) => {
        const clientTable = rootGetters['account/getCurrentClient'].table_name;
        const callString =
          '{group_name,ad_schedule,inventory,uuid,home_base,area_id,interface,contact{contact_name,phone,email},code,address{address_1,address_2,city,country},network_status,tablet_settings{brightness_day_time,brightness_off_time,brightness_day_level,brightness_night_level,brightness_use,notification_emails,notification_frequency,screenshot_frequency,send_offline_report,take_screenshots,offline_duration,warning_trigger,utilization_trigger,danger_trigger},status,error,success}';
        getAll(
          `/group?query=${encodeURIComponent(
            `{get(type_name: "group", 
              group: {uuid: "${payload}"}, 
              table_name:"${clientTable}", 
            )${callString}}`
          )}`
        )
          .then(res => {
            if (res.data.data.get) {
              const data = res.data.data.get[0];

              for (const property in data) {
                if (data[property] === 'null' || data[property] === 'NULL') {
                  data[property] = '';
                }
              }
              for (const property in data.address) {
                if (
                  data.address[property] === 'null' ||
                  data.address[property] === 'NULL'
                ) {
                  data.address[property] = '';
                }
              }

              if (data.ad_json) {
                data.ad_json = data.ad_json.replace(
                  /(['"])?([a-z0-9A-Z_]+)(['"])?:/g,
                  '"$2": '
                );
              }
              const settings = data.tablet_settings;
              if (settings && settings.notification_emails) {
                if (settings.notification_emails === 'null') {
                  data.tablet_settings.notification_emails = null;
                } else {
                  try {
                    data.tablet_settings.notification_emails = JSON.parse(
                      settings.notification_emails
                    );
                  } catch (err) {
                    console.warn(
                      `Error parsing notification_emails JSON: ${err}`
                    );
                  }
                }
              }
              if (!settings || !settings.danger_trigger) {
                if (!settings) {
                  data.tablet_settings = {};
                }
                data.tablet_settings.danger_trigger = 20;
              }
              if (!settings || !settings.warning_trigger) {
                data.tablet_settings.warning_trigger = 3;
              }
              commit('setUpdateInProgress', false);
              if (!data.contact) {
                data.contact = {};
              }
              if (!data.tablet_settings) {
                data.tablet_settings = {};
              }
              if (!data.address) {
                data.address = {};
              }
              dispatch('acquireGroupScreens', data);
            }
            resolve(res);
          })
          .catch(err => {
            commit('loading/setLoading', false, { root: true });
            reject(err);
          });
      });
    }
  },
  acquireSharkDetails: async ({ commit, dispatch }, payload) => {
    commit('setUpdateInProgress', true);
    commit('loading/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      const callString = `{
          vistar_direct,
        ad_json,
        group_name,
        club_friendly_name,
        gpsi_server,
        lat,
        lng,
          ad_schedule,
        inventory,
        uuid,
        home_base,
        launch_mode,
        interface,
        contact_name,
        phone,
        email
        address_1,
        address_2,
        city,
        state,
        country,
        zip
          status
          network_status,
        tablet_settings{
          brightness_day_time,
          brightness_off_time,
          brightness_day_level,
          brightness_night_level,
          brightness_use,
          notification_emails,
          offline_duration,
          notification_frequency,
          screenshot_frequency,
          send_offline_report,
          take_screenshots,
          warning_trigger,
          utilization_trigger,
          danger_trigger
        }
      }`;

      graphQL({
        query: `
          query {getGroup(
            uuid: "${payload}"
          ) ${callString}}
        `,
      })
        .then(res => {
          if (res.data.data.getGroup) {
            const data = res.data.data.getGroup;

            for (const property in data) {
              if (data[property] === 'null' || data[property] === 'NULL') {
                data[property] = '';
              }
            }
            for (const property in data.address) {
              if (
                data.address[property] === 'null' ||
                data.address[property] === 'NULL'
              ) {
                data.address[property] = '';
              }
            }

            if (data.ad_json) {
              data.ad_json = data.ad_json.replace(
                /(['"])?([a-z0-9A-Z_]+)(['"])?:/g,
                '"$2": '
              );
            }
            const settings = data.tablet_settings;
            if (settings && settings.notification_emails) {
              if (settings.notification_emails === 'null') {
                data.tablet_settings.notification_emails = null;
              } else {
                try {
                  data.tablet_settings.notification_emails = JSON.parse(
                    settings.notification_emails
                  );
                } catch (err) {
                  console.warn(
                    `Error parsing notification_emails JSON: ${err}`
                  );
                }
              }
            }
            if (!settings || !settings.danger_trigger) {
              if (!settings) {
                data.tablet_settings = {};
              }
              data.tablet_settings.danger_trigger = 20;
            }
            if (!settings || !settings.warning_trigger) {
              data.tablet_settings.warning_trigger = 3;
            }
            commit('setUpdateInProgress', false);
            if (!data.contact) {
              data.contact = {};
            }
            if (!data.tablet_settings) {
              data.tablet_settings = {};
            }
            if (!data.address) {
              data.address = {};
            }
            commit('setDetails', data);
            dispatch('getGroupNetworkHealth', payload);
            dispatch('getGroupCoords', payload);
          }
          resolve(res);
        })
        .catch(err => {
          commit('loading/setLoading', false, { root: true });
          reject(err);
        });
    });
  },
  getGroupNetworkHealth({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setGraphLoadingState', { name: 'networkHealth', value: true });
      graphQL({
        query: `
          query {getGroupNetworkHealth(
            uuid: "${payload}"
          ) { data }}
        `,
      })
        .then(res => {
          const chart = {
            data: res.data.data.getGroupNetworkHealth.data,
            labels: ['Good', 'Ok', 'Bad'],
          };
          commit('setSharkNetworkHealth', chart);
          commit('setGraphLoadingState', {
            name: 'networkHealth',
            value: false,
          });
          commit('loading/setLoading', false, { root: true });
          resolve(res);
        })
        .catch(err => {
          commit('loading/setLoading', false, { root: true });
          reject(err);
        });
    });
  },
  getGroupCoords({ commit }, payload) {
    return new Promise((resolve, reject) => {
      graphQL({
        query: `
          query {getGroupCoords(
            uuid: "${payload}"
          ) {
            screen_id
            group_name
            lat
            lng
          }}
        `,
      })
        .then(res => {
          commit('setSharkCoords', res.data.data.getGroupCoords);
          commit('loading/setLoading', false, { root: true });
          resolve(res);
        })
        .catch(err => {
          commit('loading/setLoading', false, { root: true });
          reject(err);
        });
    });
  },
  getScreensByGroup({ commit }, payload) {
    return new Promise((resolve, reject) => {
      getScreensByGroup(payload.id)
        .then(response => {
          commit('setScreensStatus', {
            data: response.data.Items,
            screens: payload.screens,
          });
          commit('loading/setLoading', false, { root: true });
          resolve(response);
        })
        .catch(error => {
          commit('loading/setLoading', false, { root: true });
          reject(error);
        });
    });
  },
  getInterfaceTypes({ commit }) {
    return new Promise((resolve, reject) => {
      graphQL({
        query: `
          query {
            getAllInterfaceTypes{
              uuid
              type
            }
          }
        `,
      })
        .then(res => {
          const interfaces = res.data.data.getAllInterfaceTypes.map(
            each => `${each.type[0].toUpperCase()}${each.type.slice(1)}`
          );
          commit('setInterfaceTypes', interfaces);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  acquireGroupScreens: async ({ commit, dispatch, rootGetters }, payload) =>
    new Promise((resolve, reject) => {
      let group = { group_id: payload.uuid };
      group = JSON.stringify(group).replace(/"([^"]+)":/g, '$1: ');
      const clientTable = rootGetters['account/getCurrentClient'].table_name;
      getAll(
        `/screen?query=${encodeURIComponent(
          `{get(type_name: "screen", 
            screen: ${group}, 
            table_name:"${clientTable}", 
            index: "group-index"
          ){
            uuid, 
            status,
            error,
            status,
            success
          }}`
        )}`
      )
        .then(res => {
          payload.screens = res.data.data.get;
          dispatch('getScreensByGroup', {
            id: payload.uuid,
            screens: res.data.data.get,
          });
          dispatch('getScreenCoordinateData', {
            data: payload,
            screens: res.data.data.get,
          });
          commit('setDetails', payload);
          setTimeout(() => {
            commit('setUpdateInProgress', false);
          }, 1000);
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    }),
  getScreenCoordinateData: async ({ commit, rootGetters }, payload) =>
    new Promise((resolve, reject) => {
      const clientTable = rootGetters['account/getCurrentClient'].table_name;
      getAll(
        `/coordinate?query=${encodeURIComponent(
          `{getPaginated(type_name: "coordinate", 
            coordinate: {group_id: "${payload.data.uuid}"}, 
            table_name:"${clientTable}",  
            index: "group-index",
            pageSize: "500"
          ){items{
            area_id, 
            group_id, 
            store_id, 
            screen_id, 
            session_id, 
            latitude, 
            longitude, 
            created_at, 
            timestamp, 
            error, 
            success
          }}}`
        )}`
      )
        .then(res => {
          commit('setGroupCoordinateData', {
            data: res.data.data.getPaginated.items,
            screens: payload.screens,
          });
          commit('loading/setLoading', false, { root: true });
          resolve(res);
        })
        .catch(error => {
          commit('loading/setLoading', false, { root: true });
          reject(error);
        });
    }),
  updateDetails: async ({ commit, getters, dispatch, rootGetters }) =>
    new Promise((resolve, reject) => {
      commit('setUpdateInProgress', true);
      let payload = getters.getDetails;
      if (payload.tablet_settings.notification_emails !== 'null') {
        payload.tablet_settings.notification_emails = JSON.stringify(
          payload.tablet_settings.notification_emails
        );
      }
      if (!payload.area_id) {
        delete payload.area_id;
      }
      delete payload.area;
      delete payload.users;
      delete payload.chart;
      delete payload.__typename;
      delete payload.screens;
      delete payload.devices;
      delete payload.error;
      delete payload.success;

      if (payload.ad_json) {
        payload.ad_json = JSON.stringify(JSON.parse(payload.ad_json)).replace(
          /"([^"]+)":/g,
          '$1: '
        );
      }
      payload.tablet_settings.warning_trigger = parseInt(
        payload.tablet_settings.warning_trigger
      );
      payload.tablet_settings.danger_trigger = parseInt(
        payload.tablet_settings.danger_trigger
      );
      payload = JSON.stringify(payload).replace(/"([^"]+)":/g, '$1: ');

      const clientTable = rootGetters['account/getCurrentClient'].table_name;
      let callString =
        '{group_name,ad_schedule,inventory,uuid,home_base,area_id,interface,contact{contact_name,phone,email},code,address{address_1,address_2,city,country},network_status,tablet_settings{brightness_day_time,brightness_off_time,brightness_day_level,brightness_night_level,brightness_use,notification_emails,notification_frequency,screenshot_frequency,send_offline_report,offline_duration,take_screenshots,warning_trigger,utilization_trigger,danger_trigger},status,error,success}';
      if (rootGetters['account/getCurrentClient'].client_name === 'shark') {
        callString =
          '{vistar_direct,ad_json,group_name,club_friendly_name,ad_schedule,lat,lng,inventory,gpsi_server,site_id,launch_mode,uuid,home_base,area_id,interface,contact{contact_name,phone,email},address{address_1,address_2,city,state,country,zip},network_status,tablet_settings{brightness_day_time,brightness_off_time,brightness_day_level,brightness_night_level,brightness_use,notification_emails,notification_frequency,screenshot_frequency,send_offline_report,offline_duration,take_screenshots,warning_trigger,utilization_trigger,danger_trigger},status,error,success}';
      }
      getAll(
        `/group?query=${encodeURIComponent(
          `mutation{update(type_name: "group", 
            group: ${payload}, 
            table_name:"${clientTable}", 
          )${callString}}`
        )}`
      )
        .then(res => {
          if (res.data.data.update.ad_json) {
            res.data.data.update.ad_json = res.data.data.update.ad_json.replace(
              /(['"])?([a-z0-9A-Z_]+)(['"])?:/g,
              '"$2": '
            );
          }
          const settings = res.data.data.update.tablet_settings;
          if (settings && settings.notification_emails) {
            if (settings.notification_emails === 'null') {
              res.data.data.update.tablet_settings.notification_emails = null;
            } else {
              res.data.data.update.tablet_settings.notification_emails = JSON.parse(
                settings.notification_emails
              );
            }
          }
          if (!settings.danger_trigger) {
            res.data.data.update.tablet_settings.danger_trigger = 20;
          }
          if (!settings.warning_trigger) {
            res.data.data.update.tablet_settings.warning_trigger = 3;
          }
          if (res.data.data && res.data.data.update) {
            dispatch('acquireGroupScreens', res.data.data.update);
            commit('setUpdated', true);
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    }),
};

const mutations = {
  setDetails(state, payload) {
    if (payload.tablet_settings) {
      if (moment(payload.tablet_settings.brightness_day_time)._isValid) {
        payload.tablet_settings.brightness_day_time = moment(
          payload.tablet_settings.brightness_day_time
        ).format('h:mm');
      }
      if (moment(payload.tablet_settings.brightness_off_time)._isValid) {
        payload.tablet_settings.brightness_off_time = moment(
          payload.tablet_settings.brightness_off_time
        ).format('h:mm');
      }
    }
    state.details = payload;
  },
  setScreensStatus(state, payload) {
    let green = 0;
    let yellow = 0;
    let red = 0;
    if (payload.data.length > 0) {
      payload.data.map(screen => {
        payload.screens.map(compare => {
          if (compare.uuid === screen.uuid) {
            if (screen.status && screen.status.toLowerCase() === 'green') {
              green++;
            } else if (
              screen.status &&
              screen.status.toLowerCase() === 'yellow'
            ) {
              yellow++;
            } else if (screen.status && screen.status.toLowerCase() === 'red') {
              red++;
            }
          }
        });
      });
    }
    // if (!payload.area) {
    //   payload.area = { name: "No Area Available" };
    // }
    const chart = {
      data: [green, yellow, red],
      labels: ['Good', 'Ok', 'Bad'],
    };
    state.statusChart = chart;
  },
  setSharkNetworkHealth(state, payload) {
    state.statusChart = payload;
  },
  setGroupCoordinateData(state, payload) {
    const coords = [];
    payload.data.map(coord => {
      if (coord.created_at) {
        coords.push(coord);
      }
    });
    coords.sort((a, b) =>
      b.created_at.toString().localeCompare(a.created_at.toString())
    );
    const devices = [];
    const screenIds = [];
    coords.map(coordinate => {
      if (
        screenIds.indexOf(coordinate.screen_id) < 0 &&
        coordinate.latitude !== '0.0' &&
        coordinate.longitude !== '0.0'
      ) {
        screenIds.push(coordinate.screen_id);
        devices.push(coordinate);
      }
    });
    devices.map(loc => {
      loc.lat = Number(loc.latitude);
      loc.lng = Number(loc.longitude);
      loc.infoOpen = false;
      loc.position = {
        lat: Number(loc.latitude),
        lng: Number(loc.longitude),
      };
      loc.id = loc.screen_id;
    });
    const allDevices = [];
    payload.screens.map(screen => {
      devices.map(device => {
        if (screen.uuid === device.id) {
          allDevices.push(device);
        }
      });
    });
    state.groupLocations = allDevices;
  },
  setSharkCoords(state, payload) {
    payload.map(loc => {
      loc.lat = Number(loc.lat);
      loc.lng = Number(loc.lng);
      loc.infoOpen = false;
      loc.position = {
        lat: Number(loc.lat),
        lng: Number(loc.lng),
      };
      loc.id = loc.screen_id;
    });
    state.groupLocations = payload;
  },
  setUpdateInProgress(state, payload) {
    state.updateInProgress = payload;
  },
  setEditingDetails(state, payload) {
    state.editingDetails = payload;
  },
  setUpdated(state, payload) {
    state.updated = payload;
  },
  setInterfaceTypes(state, payload) {
    state.interfaceTypes = payload;
  },
  setAdJson(state, payload) {
    state.adJson = payload;
  },
  setGraphLoadingState(state, payload) {
    state.graphLoadingStates[payload.name] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
